import { useTranslation } from 'react-i18next';

export type LangMode = 'en' | 'km' | 'zh';

export function useLanguage() {
  const { i18n } = useTranslation();
  const lang = (['en', 'km', 'zh'].includes(i18n.language) ? i18n.language : 'en') as LangMode;
  return { lang, setLang: (next: LangMode) => { void i18n.changeLanguage(next); } };
}
